import { REMOVE_PACKAGE_SUCCESS } from '../../types/packages';

export default function removePackage(state, action) {
    switch (action.type) {
        case REMOVE_PACKAGE_SUCCESS: 
            return state.filter(lookupPackage => lookupPackage.get('id') !== action.packageId);
        default:
            return state;
    }
}